import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const half = Math.ceil(categories.length / 2);
  const col1 = categories.slice(0, half);
  const col2 = categories.slice(half);

  return (
    <footer className="w-full bg-background-200/70 border-t border-background-300/60">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="inline-block font-heading text-xl font-bold text-foreground-900 mb-4 cursor-pointer">
                Hipobuy <span className="text-primary-500">Sheet</span>
              </Link>
              <p className="text-xs text-foreground-500 leading-relaxed mb-5">
                The ultimate resource hub for organized product discovery, spreadsheet-powered price research, 
                and smarter shopping decisions. Helping buyers find better fashion products since 2024.
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50 text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                  <i className="ri-twitter-x-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50 text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50 text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                  <i className="ri-pinterest-line text-sm"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">SEO Guides</h4>
              <div className="h-px bg-background-300/60 mb-4"></div>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/hipobuy-spreadsheet-guide" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                    Beginner&apos;s Guide
                  </Link>
                </li>
                <li>
                  <Link to="/spreadsheet-platform-comparison" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                    Platform Comparison
                  </Link>
                </li>
                <li>
                  <Link to="/spreadsheet-category-guide" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                    Category Deep-Dive Guide
                  </Link>
                </li>
                <li>
                  <Link to="/safe-shopping-guide" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                    Safe Shopping Guide
                  </Link>
                </li>
                <li>
                  <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                    hipobuy sheet
                  </a>
                </li>
                <li>
                  <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                    Buy It Now
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">Categories 1-7</h4>
              <div className="h-px bg-background-300/60 mb-4"></div>
              <ul className="space-y-2.5">
                {col1.map((cat) => (
                  <li key={cat.id}>
                    <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">Categories 8-14</h4>
              <div className="h-px bg-background-300/60 mb-4"></div>
              <ul className="space-y-2.5">
                {col2.map((cat) => (
                  <li key={cat.id}>
                    <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} Hipobuy Spreadsheet Hub. All rights reserved.
            </p>
            <p className="text-xs text-foreground-400">
              Built for smarter shopping. Not affiliated with any specific platform.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}